import { Toaster as SonnerToaster } from "sonner";
import { useTheme } from "@/hooks/useTheme";

/**
 * sonner with the app's theme. Its defaults are the point: ~4s auto-dismiss and a
 * visible cap with queueing, so a burst of notifications drains instead of stacking
 * into a wall the user has to click away one by one.
 */
export function Toaster() {
  const [mode] = useTheme();

  return <SonnerToaster theme={mode} position="top-center" visibleToasts={3} closeButton />;
}
